import React from "react"

import "./skill.scss"

export default function RequiredSkills() {
  const skills = ["Git", "Python", "AWS"]
  return (
    <div className="skills-wrapper p-20px mb-20px mb-lg-0">
      <h6 className="mb-4px"> Skills</h6>
      <div className="d-flex flex-wrap gap-8px">
        {skills.map(item => (
          <div className="skill" key={item}>
            <span>{item}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
